import React from 'react';

import colors from '../../../../utils/colors';
import t from '../../../../i18n/t';
import { TaskState } from 'shovel-lib/types';
import Button from '../../../common/buttons/Button';
import styled from 'styled-components';
import { withAlpha } from '@utils/colorUtils';

type Props = {
  label?: string;
  save: (state: TaskState) => void;
  // Called on the click, before the save.
  onStart?: () => void;
};

/**
 * Mark Task Complete in a session's popup: saved at once, so the popup reads as completed straight away, with the
 * session's ✓ bounce and its time flying into the week donut (`onStart`). Nothing more moves here: sparkles from the
 * button were too much on top of that (Petr). It replaced a particle effect drawn frame by frame, which got choppy and
 * ran long on a slow computer, ran fast on a 120 Hz screen, and held up the save while it played.
 */
class MarkComplete extends React.PureComponent<Props> {
  private done = false;

  handleClick = () => {
    if (this.done) return;
    this.done = true;
    this.props.onStart?.();
    this.props.save(TaskState.COMPLETED);
  };

  render() {
    return (
      <Container data-cy={'markCompleteButton'}>
        <Button onClick={this.handleClick} color={colors.positive} size={'sm'}>
          {this.props.label || t.MARK_COMPLETE}
        </Button>
      </Container>
    );
  }
}

export default MarkComplete;

// The soft green the sidebar's Mark complete gets on hover, behind the outlined button (Petr, 2026-10-09).
const Container = styled.div`
  margin-right: 10px;
  padding-top: 5px;

  button {
    transition: background-color 0.15s ease;
  }

  // At full strength rather than the buttons' usual fade, which washed the green out.
  button:hover {
    background-color: ${withAlpha(colors.positive, 0.12)};
    opacity: 1;
  }
`;
